import * as React from "react";
import type { SVGProps } from "react";

interface FreeKickProps extends SVGProps<SVGSVGElement> {
  cancelled?: boolean;
}
const FreeKick = ({ cancelled = false, ...props }: FreeKickProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    {...props}
  >
    <g>
    <g fill="none" fillRule="nonzero">
      <path
        fill="#FFF"
        d="M5 1.25a2.75 2.75 0 0 1 1.511 5.048A2.75 2.75 0 0 1 8.75 9v7a.75.75 0 0 1-.75.75H2a.75.75 0 0 1-.75-.75V9a2.75 2.75 0 0 1 2.239-2.703A2.75 2.75 0 0 1 5 1.25M6 7H4a2 2 0 0 0-2 2v7h6V9a2 2 0 0 0-2-2M5 2a2 2 0 1 0 0 4l.15-.005A2 2 0 0 0 5 2"
      />
      <path
        fill="#000"
        d="M6 7a2 2 0 0 1 2 2v7H2V9a2 2 0 0 1 2-2zM5 2a2 2 0 0 1 .15 3.995L5 6a2 2 0 0 1-.15-3.995z"
      />
      <path
        fill="#007BBD"
        d="M6 8H4a1 1 0 0 0-1 1v6h4V9a1 1 0 0 0-.883-.993zM5 3a1 1 0 1 0 0 2 1 1 0 0 0 0-2"
      />
      <path
        fill="#FFF"
        d="M12 1.25a2.75 2.75 0 0 1 1.511 5.048A2.75 2.75 0 0 1 15.75 9v7a.75.75 0 0 1-.75.75H9a.75.75 0 0 1-.75-.75V9a2.75 2.75 0 0 1 2.239-2.703A2.75 2.75 0 0 1 12 1.25M13 7h-2a2 2 0 0 0-2 2v7h6V9a2 2 0 0 0-2-2m-1-5a2 2 0 1 0 0 4l.15-.005A2 2 0 0 0 12 2"
      />
      <path
        fill="#000"
        d="M13 7a2 2 0 0 1 2 2v7H9V9a2 2 0 0 1 2-2zm-1-5a2 2 0 0 1 .15 3.995L12 6a2 2 0 0 1-.15-3.995z"
      />
      <path
        fill="#007BBD"
        d="M13 8h-2a1 1 0 0 0-1 1v6h4V9a1 1 0 0 0-.883-.993zm-1-5a1 1 0 1 0 0 2 1 1 0 0 0 0-2"
      />
      <path
        fill="#FFF"
        d="M19 16.25a3.75 3.75 0 1 0 0 7.5 3.75 3.75 0 0 0 0-7.5m0 .75a3 3 0 1 1 0 6 3 3 0 0 1 0-6"
      />
      <path fill="#000" d="M19 17a3 3 0 1 1 0 6 3 3 0 0 1 0-6" />
      <path fill="#C5C5C5" d="M19 18a2 2 0 1 0 0 4 2 2 0 0 0 0-4" />
      <path
        fill="#000"
        stroke="#FFF"
        strokeWidth={0.75}
        d="M19.655 6.91a.87.87 0 0 1 .664.086c.581.851.42 1.029.325 1.194a.87.87 0 0 1-.53.41c1.075.978 1.852 2.059 2.232 3.261.485 1.533.473 2.906-.027 4.102a.87.87 0 0 1-1.145.47.87.87 0 0 1-.47-1.146c.342-.815.328-1.777-.026-2.898q-.398-1.257-1.647-2.306c.022.268-.037.47-.15.631a.88.88 0 0 1-.489.343c-.34.04-.573-.03-.745-.15a.83.83 0 0 1-.355-.621l-.164-1.946a.87.87 0 0 1 .643-.918Z"
      />
    </g>
        {cancelled && (
        <rect
          width="25"
          height="2.5"
          x="-.494"
          y="10.746"
          fill="#000"
          fillRule="evenodd"
          stroke="#FFF"
          rx="1"
          transform="rotate(-45 12.006 11.996)"
        />
      )}
    </g>
  </svg>
);
export default FreeKick;
